import { API_ENDPOINTS, buildApiUrl } from "../config/api";

export type UserPreferences = {
  language: string;
  timezone: string;
  notify_by_email: boolean;
  notify_by_push: boolean;
  notify_by_sms: boolean;
  two_factor?: boolean;
};

type PreferencesResponse = {
  status: number;
  message: string;
  data?: Partial<UserPreferences>;
};

const DEFAULT_ERROR_MESSAGE = "Nao foi possivel processar as preferencias.";

function getAuthHeaders(withJsonContentType = false): HeadersInit {
  const token = localStorage.getItem("access_token");
  if (!token) {
    throw new Error("Token de acesso nao encontrado.");
  }
  const headers: HeadersInit = {};

  if (withJsonContentType) {
    headers["Content-Type"] = "application/json";
  }

  headers.Authorization = `Bearer ${token}`;

  return headers;
}

function resolveErrorMessage(json: PreferencesResponse | null, fallback: string): string {
  const fromData =
    json?.data && typeof json.data === "object" && "message" in json.data
      ? String((json.data as { message?: string }).message ?? "")
      : "";
  return fromData || json?.message || fallback;
}

export async function fetchUserPreferences() {
  const response = await fetch(buildApiUrl(API_ENDPOINTS.preferences), {
    method: "GET",
    headers: getAuthHeaders(),
  });

  const json = (await response.json().catch(() => null)) as PreferencesResponse | null;
  if (!response.ok) {
    throw new Error(resolveErrorMessage(json, DEFAULT_ERROR_MESSAGE));
  }

  return json?.data || null;
}

export async function updateUserPreferences(payload: UserPreferences) {
  const response = await fetch(buildApiUrl(API_ENDPOINTS.preferencesUpdate), {
    method: "PUT",
    headers: getAuthHeaders(true),
    body: JSON.stringify(payload),
  });

  const json = (await response.json().catch(() => null)) as PreferencesResponse | null;
  if (!response.ok) {
    throw new Error(resolveErrorMessage(json, DEFAULT_ERROR_MESSAGE));
  }

  return json;
}
